import type { EoTheme, EoExercise } from "@/types/eoTypes";

export const eoThemes: EoTheme[] = [
  {
    id: "theme_1",
    title: "Voyages et Tourisme",
    description: "Vocabulaire essentiel para falar sobre viagens, aeroportos e hotéis.",
    category: "Section A - Formel",
    iconName: "Plane",
    exercisesCount: 2
  },
  {
    id: "theme_2",
    title: "Recherche d'Emploi",
    description: "Vocabulaire para entrevistas de emprego, currículo e ambiente de trabalho.",
    category: "Section A - Formel",
    iconName: "Briefcase",
    exercisesCount: 2
  },
  {
    id: "theme_3",
    title: "Logement et Déménagement",
    description: "Vocabulaire para aluguel, problemas com a casa e vizinhança.",
    category: "Section B - Informel",
    iconName: "Home",
    exercisesCount: 1
  }
];

export const eoExercises: EoExercise[] = [
  {
    id: "ex_1_1",
    themeId: "theme_1",
    context: "Você está na recepção de um hotel e deseja fazer o check-in.",
    textBeforeBlank: "Bonjour, j'ai réservé une chambre au nom de Dupont. Voici ma carte d'identité et ma ",
    textAfterBlank: " de réservation.",
    options: ["facture", "confirmation", "valise", "demande"],
    correctOption: "confirmation",
    explanation: "Em francês, para mostrar que você reservou algo, você apresenta uma 'confirmation de réservation' (confirmação de reserva). 'Facture' significa fatura/conta, o que vem depois."
  },
  {
    id: "ex_1_2",
    themeId: "theme_1",
    context: "Você precisa saber o horário do café da manhã no hotel.",
    textBeforeBlank: "Excusez-moi, à quelle heure est-ce que le petit-déjeuner est ",
    textAfterBlank: " ?",
    options: ["servi", "mangé", "ouvert", "payé"],
    correctOption: "servi",
    explanation: "Diz-se 'le petit-déjeuner est servi' (o café da manhã é servido). Não usamos 'ouvert' (aberto) diretamente para a refeição, mas sim para o restaurante."
  },
  {
    id: "ex_2_1",
    themeId: "theme_2",
    context: "Em uma entrevista de emprego, você fala sobre suas qualificações.",
    textBeforeBlank: "J'ai obtenu mon ",
    textAfterBlank: " en ingénierie l'année dernière.",
    options: ["bureau", "diplôme", "collègue", "travail"],
    correctOption: "diplôme",
    explanation: "O termo 'diplôme' (diploma/graduação) é o correto. 'Bureau' é escritório, e 'travail' é trabalho."
  },
  {
    id: "ex_2_2",
    themeId: "theme_2",
    context: "Você está perguntando sobre as oportunidades de crescimento na empresa.",
    textBeforeBlank: "Quelles sont les perspectives d'",
    textAfterBlank: " au sein de votre entreprise ?",
    options: ["augmentation", "évolution", "abandon", "échec"],
    correctOption: "évolution",
    explanation: "'Perspectives d'évolution' refere-se às oportunidades de crescimento e promoção na carreira dentro da empresa."
  },
  {
    id: "ex_3_1",
    themeId: "theme_3",
    context: "Conversando com um amigo sobre a mudança para um novo apartamento.",
    textBeforeBlank: "Je dois signer le ",
    textAfterBlank: " de location demain matin.",
    options: ["bail", "livre", "chèque", "propriétaire"],
    correctOption: "bail",
    explanation: "O contrato de aluguel em francês é chamado de 'bail'. 'Propriétaire' significa proprietário/senhorio."
  }
];
